import { __rest } from "tslib";
import React, { useCallback } from 'react';
import cx from 'classnames';
import { compose } from 'redux';
import { withRouter } from "../../Helpers/withRouter";
import { Button } from 'panamera-react-ui';
var css = {
  "actionButton": "oalp-1NFBh"
};
import { connect } from 'react-redux';
import { UNKNOWN } from "../../Constants/locations";
import { getTrackingOrigin } from "../../Store/Selectors/layout";
import { HOME_INSPECTION_CTA_NAME, HOW_TO_SELL_CAR_WIDGET_CTA_NAME, FAQ_WIDGET_DESKTOP, FAQ_WIDGET_MOBILE, HOW_TO_SELL_CAR_DESKTOP, HOW_TO_SELL_CAR_MOBILE, VALUATION_EVALUATE_ANOTHER_CAR, UPAGO_CAR_CTA, SELL_YOUR_CAR_CTA_NAME, SELL_HOME_TAP_CONTINUE } from "../../Constants/templateName";
import OnClickActionsMap from "./ClickActions/OnClickActionsMap";
import { mapDispatchToProps as mapDispatchToPropsCTA } from "../../Widgets/NumberPlateInputWithLink/NumberPlateInputWithLink";
import TrackingInfoManager from "../../Utils/TrackingInfoManager";
import withConfig from "../../ComponentDependency/withConfig";
import CookieManager from "../../Utils/CookieManager";
import LocalStorageHelper from "../../Utils/LocalStorageHelper";
import { TRACKING_EVENTS } from "../../Constants/trackingEvents";
import { SELLER_STATE_COOKIE, EVALUATION_STATES, FLOW_TYPES, EVALUATION_STATES_TRACKING } from "../../Constants/evaluation";
import UserSession from "../../Utils/UserSession";
export var CTA = function CTA(_a) {
  var _a$button = _a.button,
    action = _a$button.action,
    style = _a$button.style,
    invert = _a$button.invert,
    type = _a$button.type,
    text = _a$button.text,
    name = _a$button.name,
    icon = _a$button.icon,
    iconPlacement = _a$button.iconPlacement,
    iconSize = _a$button.iconSize,
    _a$button$disabled = _a$button.disabled,
    disabled = _a$button$disabled === void 0 ? false : _a$button$disabled,
    _a$button$dynamicQuer = _a$button.dynamicQueryParams,
    dynamicQueryParams = _a$button$dynamicQuer === void 0 ? {} : _a$button$dynamicQuer,
    iconColorValue = _a$button.iconColorValue,
    fetchCXELayout = _a$button.fetchCXELayout,
    _a$customClass = _a.customClass,
    customClass = _a$customClass === void 0 ? '' : _a$customClass,
    browsingMode = _a.browsingMode,
    origin = _a.origin,
    handleCallbackClick = _a.handleCallbackClick,
    handleIconClick = _a.handleIconClick,
    track = _a.track,
    metadata = _a.metadata,
    widgetKey = _a.widgetKey,
    router = _a.router,
    locationId = _a.locationId,
    onTrack = _a.onTrack,
    toggleShowAllCTA = _a.toggleShowAllCTA,
    config = _a.config,
    handleOnClick = _a.handleOnClick,
    dynamicParamsValues = _a.dynamicParamsValues,
    landingURLSearch = _a.landingURLSearch,
    rest = __rest(_a, ["button", "customClass", "browsingMode", "origin", "handleCallbackClick", "handleIconClick", "track", "metadata", "widgetKey", "router", "locationId", "onTrack", "toggleShowAllCTA", "config", "handleOnClick", "dynamicParamsValues", "landingURLSearch"]);
  var onClick = useCallback(function (evt) {
    var trackingEventName = '';
    var isMxCl = config && config.get('olxAutos', 'isMXCL');
    var dynamicKeys = Object.keys(dynamicQueryParams);
    var templateName = [HOME_INSPECTION_CTA_NAME, VALUATION_EVALUATE_ANOTHER_CAR, SELL_YOUR_CAR_CTA_NAME];
    if (templateName.includes(name) || dynamicKeys.length) {
      evt.preventDefault();
    }
    if (track) {
      var trackingInfo = TrackingInfoManager.getTrackingInfo({
        browsing_location_id: locationId || UNKNOWN,
        browsing_mode: browsingMode,
        origin: origin,
        flow_type: FLOW_TYPES.NO_DRAFT,
        reason: CookieManager.readCookie(SELLER_STATE_COOKIE) || EVALUATION_STATES.INITIAL
      });
      if (metadata && metadata.trackingInfo && metadata.trackingInfo.clickEvent && metadata.trackingInfo.clickEvent.name) {
        if (widgetKey === FAQ_WIDGET_DESKTOP || widgetKey === FAQ_WIDGET_MOBILE) {
          trackingEventName = metadata.trackingInfo.clickEventSeeMore.name;
        } else if (widgetKey === HOW_TO_SELL_CAR_DESKTOP || widgetKey === HOW_TO_SELL_CAR_MOBILE) {
          trackingEventName = metadata.trackingInfo.clickEvent.name;
        } else {
          trackingEventName = metadata.trackingInfo.clickEvent.name;
          trackingInfo['chosen_option'] = text;
        }
        if (metadata.trackingInfo.clickEvent.selectFrom) {
          trackingInfo.select_from = metadata.trackingInfo.clickEvent.selectFrom;
        }
      } else if (rest.select_from) {
        trackingInfo.select_from = rest.select_from;
      }
      if (!isMxCl) {
        trackingInfo['variants_shown'] = widgetKey;
        trackingInfo['chosen_option'] = name;
        trackingInfo.reason = CookieManager.readCookie(SELLER_STATE_COOKIE) || EVALUATION_STATES.INITIAL;
        trackingEventName = trackingEventName || TRACKING_EVENTS.OLXAUTOS_WIDGET_BUTTON_CLICKED;
      }
      var lead_id = LocalStorageHelper.getItem('lead_id');
      if (lead_id) {
        trackingInfo.lead_id = lead_id;
      }
      if (name !== VALUATION_EVALUATE_ANOTHER_CAR) {
        track(trackingEventName, trackingInfo);
      }
    }
    if (onTrack) {
      onTrack(name);
    }
    if (evt.defaultPrevented && action && name != UPAGO_CAR_CTA && name != SELL_YOUR_CAR_CTA_NAME) {
      if (name === HOME_INSPECTION_CTA_NAME) {
        var urlPath = action.split('?');
        var pathName = urlPath[0];
        var query = urlPath[1];
        router === null || router === void 0 ? void 0 : router.push({
          pathname: pathName,
          search: query ? "?".concat(query) : ''
        }, {
          state: {
            selectedTab: 1
          }
        });
      } else if (dynamicKeys.length && dynamicParamsValues) {
        var modifiedAction = action;
        for (var i in dynamicKeys) {
          if (action.indexOf(dynamicKeys[i]) > -1) {
            modifiedAction = modifiedAction.replace("$".concat(dynamicKeys[i], "$"), dynamicParamsValues[dynamicQueryParams[dynamicKeys[i]]] || '');
          }
        }
        window.open(modifiedAction, 'blank');
      } else if (name === VALUATION_EVALUATE_ANOTHER_CAR) {
        UserSession.deleteLastSelectionOption();
        UserSession.deleteEvaluationFormValues();
        UserSession.deleteEvaluationPredictedPrice();
        if (track) {
          var _trackingInfo = TrackingInfoManager.getTrackingInfo({
            browsing_location_id: locationId || UNKNOWN,
            browsing_mode: browsingMode,
            origin: origin,
            flow_type: FLOW_TYPES.NO_DRAFT,
            reason: CookieManager.readCookie(SELLER_STATE_COOKIE) || EVALUATION_STATES.APPOINTMENT_CREATED
          });
          _trackingInfo.select_from = EVALUATION_STATES_TRACKING.BOOKING_CONFIRMATION;
          _trackingInfo['chosen_option'] = VALUATION_EVALUATE_ANOTHER_CAR;
          track(SELL_HOME_TAP_CONTINUE, _trackingInfo);
        }
        if (handleIconClick) {
          handleIconClick(EVALUATION_STATES.APPOINTMENT_CREATED);
          router === null || router === void 0 ? void 0 : router.push(action);
        }
      } else {
        router === null || router === void 0 ? void 0 : router.push(action);
      }
    }
    if (fetchCXELayout && handleCallbackClick) {
      evt.preventDefault();
      evt.stopPropagation();
      handleCallbackClick(name);
    }
    if (OnClickActionsMap[name]) {
      if (name === HOW_TO_SELL_CAR_WIDGET_CTA_NAME) {
        var landingPageRoutes = config.get('landingPageRoutes', 'sell-organic');
        router === null || router === void 0 ? void 0 : router.push(landingPageRoutes);
        toggleShowAllCTA(false);
      }
      import("./ClickActions/CTAActions").then(function (ctaActions) {
        var actions = ctaActions["default"];
        if (name === SELL_YOUR_CAR_CTA_NAME) {
          actions[OnClickActionsMap[name]](action);
        } else {
          actions[OnClickActionsMap[name]]();
        }
      });
    }
    if (handleOnClick) {
      handleOnClick(name);
    }
  }, [config, dynamicQueryParams, name, track, onTrack, action, handleCallbackClick, handleOnClick, locationId, browsingMode, origin, metadata, rest.select_from, widgetKey, text, dynamicParamsValues, router, toggleShowAllCTA]);
  return /*#__PURE__*/React.createElement(Button, {
    className: cx(css.actionButton, customClass),
    type: "".concat(type, "Btn"),
    fixed: style && style.width === 'full',
    invert: invert,
    style: style,
    onClick: onClick,
    href: action,
    key: "".concat(name, "-cta"),
    icon: icon,
    iconPlacement: iconPlacement,
    iconSize: iconSize,
    "data-aut-id": rest['data-aut-id'],
    disabled: disabled,
    iconColorValue: iconColorValue
  }, text);
};
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    browsingMode: state.track.browsingMode,
    origin: getTrackingOrigin(state, props.location == null ? null : props.location, props.config),
    landingURLSearch: state.track.landingURLSearch
  };
};
export default compose(withConfig, withRouter, connect(mapStateToProps, mapDispatchToPropsCTA))(CTA);